<div class="all-content">
  <div class="top">
    {{ getLanguages('corporations') }}
  </div>
  <div class="row">
    <div class="div-search" [ngClass]="isSearch ? 'div-search-fixed' : ''">
      <div class="search">
          <input type="text" [(ngModel)]="text" (keyup.enter)="searchNodes()">
          <i class="fas fa-xmark cancel-search" *ngIf="isSearch" (click)="clearFilter()"></i>
      </div>
      <button (click)="searchNodes()">
          {{ getLanguages('search') }}
      </button>

      <div class="filter-section count-proccess" *ngIf="isSearch">
        <div class="filter" *ngIf="filterArray?.length > 0">
          {{ filterCursor }}           
          {{ getLanguages('businessSolution/search/of') }}        
          {{ filterArray?.length }}
          <button class="button-navigation" (click)="previous()" [class.disabled-button-filter]="filterCursor === 1" [disabled]="filterCursor === 1"> <i class="fas fa-chevron-left"></i> </button>
          <button class="button-navigation" (click)="next()"  [class.disabled-button-filter]="filterCursor === filterArray.length" [disabled]="filterCursor === filterArray.length"> <i class="fas fa-chevron-right"></i> </button>
        </div>
        <span *ngIf="filterArray?.length == 0">
          {{ getLanguages('businessSolution/search/noResult') }}        
        </span>
      </div>  
    </div>
  </div>

  <div class="content">
    <div class="title">
      <span>
        {{ getLanguages('corporations/tree') }}
      </span>
      <i class="fa-solid fa-chevron-right" [ngClass]="!openTree ? 'openned' : 'closed'" (click)="flipTree()"></i>
    </div>
    <app-loading *ngIf="isLoading"></app-loading>

      <div class="noData" *ngIf="noData && !isLoading">
        <div class="icon">
          <i class="fa-solid fa-exclamation"></i>
        </div>
        <span>
          {{ getLanguages('errors/noData')}}
        </span>
      </div>
    <div class="content-content">
      <div class="tree">
        <p-tree class="ptree"
          [value]="files"
          *ngIf="!isLoading && !noData"
          selectionMode="single"
          [(selection)]="selectedFile">
          <ng-template let-node pTemplate="default">
            <div class="pcontent">
              <!-- <div class="ptitle" [ngStyle]="{'width': 'calc(100vw - 30vh - 40px - 1.3 * ' + getParentCount(node) + 'vw)',
                  'min-width': 'calc(500px - 16 * ' + getParentCount(node) + 'px)'}"> -->
              <div class="ptitle">
                <i [ngClass]="getClass(node)"> </i>
                <div [class.first-column]="isFirstColumn(node)">
                  <!-- <ng-container *ngFor="let itemArray of node.arrayText">
                    <div [class.highlighted]="itemArray === searchText" style="white-space: pre-wrap;">{{ itemArray }}</div>
                  </ng-container> -->
                   <ng-container *ngIf="!node.arrayText || node.arrayText.length === 0">
                    <span [ngClass]="filterArray.includes(node.uuid) ? 'title-destak' : ''">
                      {{ (node && node.name ? node.name : '') }}
                    </span>
                  </ng-container>
                </div>
              </div>
              <div class="picons">
                <!-- aqui tinha o node.access no ngIf -->
                <div class="button" matTooltip="{{ getLanguages('corporations/info/businessSolutions') }}"  (click)="navigate(node, '/business_solutions')"
                *ngIf="haveAccess(node.uuid, 'corporations', 'business_solutions')">
                  <i class='fas fa-folder-tree i'></i>
                </div>
                <!-- aqui tinha o node.access no ngIf -->
                <div class="button" matTooltip="{{ getLanguages('corporations/info/personas') }}" (click)="navigate(node, '/organizational_structure')"
                *ngIf="haveAccess(node.uuid, 'corporations', 'organizational_structure')">
                  <i class='fas fa-users i'></i>
                </div>
                <!-- aqui tinha o node.access no ngIf -->
                <div class="button" matTooltip="{{ getLanguages('corporations/info/dimension') }}" (click)="toggleDimensionModalEdit($event, node)"
                *ngIf="haveAccess(node.uuid, 'corporations', 'dimension')">
                  <i class='fas fa-pager i'></i>
                </div>
                <!-- aqui tinha o node.access no ngIf -->
                <div class="button" matTooltip="{{ getLanguages('corporations/info/edit') }}" (click)="toggleFoundationModalEdit($event, node)"
                *ngIf="haveAccess(node.uuid, 'corporations', 'edit')">
                  <i class='fas fa-pen-to-square i'></i>
                </div>
                <!-- aqui tinha o node.access no ngIf -->
                <div class="button" matTooltip="{{ getLanguages('corporations/info/delete') }}" (click)="toggleFoundationModalDelete($event, node)"
                *ngIf="!node.is_principal && (node.size == 0 || !node.size) && haveAccess(node.uuid, 'corporations', 'delete')
                ">
                  <i class="fas fa-solid fa-trash i"></i>
                </div>
                <!-- aqui tinha o node.access no ngIf -->
                <div class="button" matTooltip="{{ getLanguages('corporations/info/newCorporation') }}" (click)="toggleFoundationModal($event, node)"
                *ngIf="getSystemPermission('corporations', 'create')">
                  <i class='fas fa-plus i'></i>
                </div>
              </div>
            </div>
          </ng-template>
        </p-tree>
      </div>
    </div>
  </div>
</div>


<div class="background-modals" *ngIf="isShowFoundationCreate || isShowFoundationEdit || isShowFoundationDelete || isShowDimensionEdit">
  <ng-container *ngIf="isShowFoundationCreate">
    <app-create-foundation (toggleFoundationModal)="toggleFoundationModal()" [properties]="properties" [parameters]="parameters" (getCorporationTree)="getCorporationTree()"></app-create-foundation>
  </ng-container>

  <ng-container *ngIf="isShowFoundationEdit">
    <app-edit-foundation (toggleFoundationModalEdit)="toggleFoundationModalEdit()" [properties]="properties" [parameters]="parameters" (getCorporationTree)="getCorporationTree()"></app-edit-foundation>
  </ng-container>

  <ng-container *ngIf="isShowFoundationDelete">
    <app-delete-component (toggleFoundationModalDelete)="toggleFoundationModalDelete()" (getCorporationTree)="getCorporationTree()" [parameters]="parameters" [type]="2"></app-delete-component>
  </ng-container>

  <ng-container *ngIf="isShowDimensionEdit">
      <app-create-dimensions (toggleDimensionModalEdit)="toggleDimensionModalEdit()" [properties]="properties" [parameters]="parameters" (getCorporationTree)="getCorporationTree()"></app-create-dimensions>
  </ng-container>
</div>
